import { render } from "./PaperSelect.vue?vue&type=template&id=4366ea32"
import script from "./PaperSelect.vue?vue&type=script&lang=js"
export * from "./PaperSelect.vue?vue&type=script&lang=js"
script.render = render

export default script